import { createRoute, redirect } from '@tanstack/react-router'

import { parsePositiveInt } from './params.ts'
import { registrationListLink, validateRegistrationSearch } from './registrations.tsx'
import { rootRoute } from './root.tsx'

// The requests had a menu entry of their own until 31.10.2026, when they became a tab of the
// incarichi: a link already sent to a colleague still lands on the same queue or request.

const legacyQueueRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/registrations',
  validateSearch: validateRegistrationSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/appointments/requests', search, replace: true })
  },
})

const legacyRequestRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/registrations/$id',
  beforeLoad: ({ params }) => {
    const id = parsePositiveInt(params.id)
    if (id === null) throw redirect({ ...registrationListLink, replace: true })
    throw redirect({ to: '/appointments/requests/$id', params: { id }, replace: true })
  },
})

export const LEGACY_REGISTRATION_ROUTES = [legacyQueueRoute, legacyRequestRoute] as const
